import * as React from 'react';
import styles from './ResidentHeader.module.css';
import { Panel, Avatar, NumberPanel, NumberPanelProps, Dropdown } from '@ixicare/ui';
import { t } from '~/i18n';
import { ProfileGender } from '@ixicare/resources';
import AlertCallModal from '~containers/Alerts/AlertCallModal';
import UserProfileEntry from '~store/Profile/UserProfileEntry';
interface ResidentHeaderProps {
  residentId: number;
  name: string;
  profileImage?: string;
  gender?: ProfileGender;
  numbers: NumberPanelProps[];
  showEditProfile?: boolean;
  siteName?: string;
  profile?: UserProfileEntry;

  onDelete: () => void;
}

const ResidentHeader: React.FC<ResidentHeaderProps> = ({
  name,
  residentId,
  showEditProfile,
  numbers,
  profileImage,
  gender,
  onDelete,
  siteName,
  profile,
}) => {
  const [showCallModal, setShowCallModal] = React.useState(false);
  const phoneNumbers = React.useMemo(() => {
    const data: { label: string; value: string }[] = [];
    if (profile?.ownedDevice?.phoneNumber) {
      data.push({ label: t('alert.call.devicePhoneNumber'), value: profile?.ownedDevice?.phoneNumber });
    }
    if (profile?.phoneNumber) {
      data.push({ label: t('alert.call.residentPrimaryPhoneNumber'), value: profile.phoneNumber });
    }
    if (profile?.secondaryPhoneNumbers) {
      data.push({ label: t('alert.call.residentSecondaryPhoneNumber'), value: profile.secondaryPhoneNumbers });
    }
    return data;
  }, [alert, profile]);

  const handleCall = React.useCallback(() => {}, [alert]);

  return (
    <>
      <Panel className={styles.Panel}>
        <div className={styles.AvatarWrapper}>
          <Avatar className={styles.Avatar} gender={gender} src={profileImage} />
        </div>
        <div className={styles.ResidentInfo}>
          {showEditProfile ? (
            <div className={styles.Settings}>
              <Dropdown
                icon="more"
                options={[
                  {
                    label: t('residentDetail.actions.edit'),
                    icon: 'edit',
                    route: {
                      href: `/residents/${residentId}/edit`,
                    },
                  },
                  {
                    label: t('residentDetail.actions.delete'),
                    icon: 'delete',
                    onClick: onDelete,
                  },
                ]}
              />
            </div>
          ) : (
            <></>
          )}

          <h1>{name}</h1>
          <h5>{siteName}</h5>
        </div>
        <div className={styles.Numbers}>
          {numbers.map((num) => (
            <NumberPanel key={`header-numb-${num.icon}`} {...num} withoutBackground />
          ))}
        </div>
      </Panel>
      {showCallModal && (
        <AlertCallModal phoneNumbers={phoneNumbers} onClose={() => setShowCallModal(false)} onCall={handleCall} />
      )}
    </>
  );
};

export default ResidentHeader;
